export default {
  "content": "<path d=\"M14.957 13.543l-1.414 1.414-4.5-4.5 1.414-1.415 4.5 4.5z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.37 1.224a1 1 0 011.337.068l3 3a1 1 0 010 1.415l-.086.085a1 1 0 000 1.415l.172.171a1 1 0 001.414 0l.086-.086.076-.068a1 1 0 011.338.068l3 3a1 1 0 010 1.415l-11 11a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.415l.086-.085a1 1 0 000-1.415l-.172-.171a1 1 0 00-1.414 0l-.086.086a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.415l11-11 .076-.068zM3.413 13l1.679 1.68a3 3 0 013.528.528l.172.171a3 3 0 01.527 3.528l1.68 1.68L20.586 11l-1.68-1.68a3 3 0 01-3.527-.528l-.172-.171a3 3 0 01-.528-3.529l-1.68-1.678-9.585 9.585z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};